export type RetryConfig =
  | { enabled: false }
  | {
      enabled: true;
      retryCount: number;
      delay: number;
      backoffFactor: number;
    };

export const RETRY_DELAY_INITIAL_VALUE = 1500;
export const BACKOFF_FACTOR_INITIAL_VALUE = 2;
export const RETRY_COUNT_INITIAL_VALUE = 1;

/**
 * Returns default retry configuration based on data source type
 * Different applications have different reliability characteristics
 */
export function getDefaultRetryConfig(isAutomaticDataSource: boolean): RetryConfig {
  if (isAutomaticDataSource) {
    return {
      enabled: true,
      retryCount: RETRY_COUNT_INITIAL_VALUE,
      delay: RETRY_DELAY_INITIAL_VALUE,
      backoffFactor: BACKOFF_FACTOR_INITIAL_VALUE,
    };
  }

  return {
    enabled: false,
  };
}
